<template>
  <div>
    <img v-bind:src="getMapSrc" :style="'width: ' + width +  'px;border: 1px solid rgba(0,0,0,0.86); max-width:none'"/>
    <div class="wrapper">
      <div class="workspace" ref="workspace">
        <FreeTransform
          v-for="element in elements"
          :key="element.id"
          :x="element.x*(width / 610)"
          :y="element.y*(width / 610)"
          :scale-x="element.scaleX"
          :scale-y="element.scaleY"
          :width="element.width"
          :height="element.height"
          :angle="element.angle"
          :offset-x="offsetX"
          :offset-y="offsetY"
          :disable-scale="element.disableScale === true"
          @mousedown="mousedown"
          @update="update(element.id, $event)"
        >
          <div :id="element.id" class='arrow_box arrow_color' :class="element.class" :style="element.styles">
            {{ element.text }}
          </div>
        </FreeTransform>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import FreeTransform from 'vue-free-transform'
  import StoreFloorProxy from "../../../../proxies/StoreFloorProxy";
  import MediaInfoProxy from "../../../../proxies/MediaInfoProxy";
  import {uuid} from 'vue-uuid';

  export default {
    name: "MapComponent",
    components: {
      FreeTransform
    },
    created: function () {
      this.findAllMediaPosition(this.storeFloorSeq);
    },
    mounted() {
      this.offsetX = this.$refs.workspace.offsetLeft;
      this.offsetY = this.$refs.workspace.offsetTop;
      this.applyCSS();
    },
    props: ['storeFloorSeq', 'storeSeq', 'mediaType', 'readOnly', 'width'],
    computed: {
      getMapSrc: function () {
        return "/api/common/store/" + this.storeSeq + "/store-floors/" + this.storeFloorSeq + "?" + this.reloadImage;
      }
    },
    methods: {
      mousedown(v) {
        if (!this.readOnly) {
          let tElement = this.getElementById(v.target.id);
          this.$emit('mousedown', tElement);
        }
      },
      update(id, payload) {
        if (!this.readOnly) {
          this.elements = this.elements.map(item => {
            if (item.id === id) {
              return {
                ...item,
                ...payload
              };
            }
            return item;
          });
        }
      },
      findAllMediaPosition(storeFloorSeq) {
        new StoreFloorProxy({mediaType: this.mediaType})
          .findAllMediaPosition(storeFloorSeq)
          .then((response) => {
            response.mediaPositions.forEach(mediaPosition => {
              this.elements.push({
                id: mediaPosition.positionId,
                x: mediaPosition.x,
                y: mediaPosition.y,
                scaleX: 1,
                scaleY: 1,
                width: 1,
                height: 1,
                angle: 0,
                color: mediaPosition.color,
                text: mediaPosition.positionText,
                mediaInfoSeq: mediaPosition.mediaInfoSeq,
                class: mediaPosition.className,
                styles: {
                  background: mediaPosition.color
                },
              });
            });
          })
      },
      applyCSS() {
        let style = document.createElement("style");
        this.$el.appendChild(style);

        new MediaInfoProxy({searchName: null, searchMediaType: null})
          .all()
          .then((response) => {
            let cssRule = "";
            response.mediaInfos.forEach(mediaInfo => {
              cssRule += `.left` + mediaInfo.mediaInfoSeq + `:after { border-right-color: ` + mediaInfo.color + ` !important;} .left` + mediaInfo.mediaInfoSeq + `:before { border-right-color: ` + mediaInfo.color + ` !important;}`;
              cssRule += `.top` + mediaInfo.mediaInfoSeq + `:after { border-bottom-color: ` + mediaInfo.color + ` !important;} .top` + mediaInfo.mediaInfoSeq + `:before { border-bottom-color: ` + mediaInfo.color + ` !important;}`;
              cssRule += `.right` + mediaInfo.mediaInfoSeq + `:after { border-left-color: ` + mediaInfo.color + ` !important;} .right` + mediaInfo.mediaInfoSeq + `:before { border-left-color: ` + mediaInfo.color + ` !important;}`;
              cssRule += `.bottom` + mediaInfo.mediaInfoSeq + `:after { border-top-color: ` + mediaInfo.color + ` !important;} .bottom` + mediaInfo.mediaInfoSeq + `:before { border-top-color: ` + mediaInfo.color + ` !important;}`;
            });
            style.innerHTML = cssRule;
          });
      },
      getElementById(id) {
        return this.elements.filter(function (el) {
          return el.id === id
        })[0];
      },
      changeDirection(value, id) {
        let tElement = this.getElementById(id);
        let font_color = "";
        if(tElement.class.indexOf("font_color_black") >= 0) {
          font_color = " font_color_black";
        } else {
          font_color = " font_color_white";
        }
        tElement.class = value + "_box " + value + tElement.mediaInfoSeq + font_color;
      },
      changeFontColor(value, id) {
        let tElement = this.getElementById(id);
        tElement.class = tElement.class.replace(" font_color_black", "");
        tElement.class = tElement.class.replace(" font_color_white", "");
        tElement.class = tElement.class + " font_color_" + value;
      },
      deleteElementById(id) {
        this.elements = this.elements.filter(function (element) {
          return element.id !== this.id;
        }, {id : id});
      },
      changePosition(value, id) {
        let tElement = this.getElementById(id);
        tElement.text = value;
      },
      addMediaInfo(row) {
        let id = uuid.v1();
        this.elements.push({
          id: id,
          x: 0,
          y: 0,
          scaleX: 1,
          scaleY: 1,
          width: 1,
          height: 1,
          angle: 0,
          text: "0",
          mediaInfoSeq: row.mediaInfoSeq,
          class: "top_box top" + row.mediaInfoSeq,
          color: row.color,
          styles: {
            background: row.color
          },
        });
      },
      getElements() {
        return this.elements;
      },
      reloadMap(size) {
        this.reloadImage = size;
      }
    },
    data() {
      return {
        elements: [],
        offsetX: 0,
        offsetY: 0,
        reloadImage: "1",
      }
    }
  }
</script>

<style scoped>
  .arrow_box {
    font-size: 10px;
    color: #fff;
    font-weight: bolder;
    user-select: none;
    cursor: pointer;
    position: absolute;
    display: inline-block;
    padding: 0.3em 0.5em;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .arrow_box:after, .arrow_box:before {
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:after {
    border-color: rgba(136, 183, 213, 0);
    border-width: 4px;
  }

  .arrow_box:before {
    border-color: rgba(194, 225, 245, 0);
    border-width: 4px;
  }

  .top_box:after, .top_box:before {
    bottom: 100%;
    left: 50%;
  }

  .right_box:after, .right_box:before {
    left: 100%;
    top: 50%;
  }

  .bottom_box:after, .bottom_box:before {
    top: 100%;
    left: 50%;
  }

  .left_box:after, .left_box:before {
    right: 100%;
    top: 50%;
  }

  .top_box:after {
    margin-left: -4px;
  }

  .top_box:before {
    margin-left: -4px;
  }

  .right_box:after {
    margin-top: -4px;
  }

  .right_box:before {
    margin-top: -4px;
  }

  .bottom_box:after {
    margin-left: -4px;
  }

  .bottom_box:before {
    margin-left: -4px;
  }

  .left_box:after {
    margin-top: -4px;
  }

  .left_box:before {
    margin-top: -4px;
  }

  .font_color_black {
    color: #000;
  }

  .font_color_white {
    color: #fff;
  }

  .wrapper {
    flex: 1;
    position: absolute;
    width: 610px;
    height: 0px;
  }

  .workspace {
    width: 610px;
    height: 0px;
    /*box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);*/
    /*border: 1px solid rgba(0, 0, 0, 0.1);*/
  }

  * {
    box-sizing: border-box;
  }

  .tr-transform__content {
    user-select: none;
  }
</style>
